import React, { PureComponent } from "react";
import { withTranslation } from "react-i18next";
import { Typeahead } from "react-bootstrap-typeahead";
import Price from "./price";
import authService from "../services/authService";
import dbService from "../services/dbService";

class HeroImage2 extends React.PureComponent {
  state = {
    prices: [],
    loading: true,
    error: null,
    commodities: [],
    commoditiesLoading: true,
  };

  // Fetch data when component mounts
  async componentDidMount() {
    try {
      // Login once for all MongoDB operations
      await authService.loginAnonymous();
      // Fetch both data sources in parallel
      this.fetchPriceData();
      this.fetchCommodities();
    } catch (error) {
      console.error('Error during anonymous login:', error);
      this.setState({
        loading: false,
        commoditiesLoading: false,
        error: 'Authentication failed'
      });
    }
  }

  // Function to fetch commodities from MongoDB
  fetchCommodities = async () => {
    try {
      const commoditiesData = await dbService.getCommoditiesForSearch();
      console.log('Loaded commodities:', commoditiesData?.length || 0);
      this.setState({
        commodities: commoditiesData || [],
        commoditiesLoading: false,
      });
    } catch (error) {
      console.error('Error fetching commodities:', error);
      this.setState({
        commoditiesLoading: false,
      });
    }
  };

  // Function to fetch price data from MongoDB
  fetchPriceData = async () => {
    try {
      const priceData = await dbService.getPriceTickerData();
      this.setState({
        prices: priceData,
        loading: false,
        error: null
      });
    } catch (error) {
      console.error('Error fetching price data:', error);
      this.setState({
        loading: false,
        error: error.message || 'Error loading price data'
      });
    }
  };

  // Handle commodity selection
  handleSelection = (selected) => {
    if (selected.length > 0) {
      const selectedOption = selected[0];
      window.open("https://app.rawbids.com/demo/commodity/" + selectedOption._id.toString(), "_blank");
    }
  };

  render() {
    const { t } = this.props;
    const { prices, loading, error, commodities, commoditiesLoading } = this.state;

    return (
      <>
        <section
          className="big-section cover-background mt-0 mb-4 mx-1 mx-sm-3"
          style={{
            borderRadius: 30,
            margin: 20,
            marginTop: 5,
          }}
        >
          <div
            className="opacity-extra-medium-2 bg-dark-slate-blue"
            style={{ opacity: 0.5, backgroundColor: "#151b2a" }}
          />
          <div className="container">
            <div className="row pt-5 pb-5">
              <div className="col-12 col-xl-12 col-lg-12 col-md-12 overlap-gap-section pb-5">
                <h2
                  className="alt-font text-white font-weight-600 wow animate__fadeIn text-uppercase mb-2 herotitle"
                  style={{ visibility: "visible", animationName: "fadeIn" }}
                >
                  {t("title353")}
                </h2>
                <h2
                  className="alt-font text-white font-weight-600 wow animate__fadeIn mb-3 text-uppercase herotitle"
                  style={{ visibility: "visible", animationName: "fadeIn" }}
                >
                  {t("title354")}
                </h2>
                <h6
                  className="text-white alt-font text-uppercase letter-spacing-1px text-uppercase wow animate__fadeIn herosubtitle"
                  style={{ visibility: "visible", animationName: "fadeIn" }}
                >
                  {t("title355")}
                </h6>
              </div>
              <div className="col-12 col-lg-6">
                <div className="">
                  <div className="input-group p-3 bg-white" style={{ borderRadius: 8 }}>
                    <Typeahead
                      id="custom-typeahead"
                      options={commodities}
                      labelKey={(option) => (option.title && option.title.en ? option.title.en : "Unknown Title")}
                      placeholder="Vitamins, Minerals, Plant Extracts,..."
                      onChange={this.handleSelection}
                      size="lg"
                      className="form-control form-control-lg p-0 border-none border-0"
                      renderMenuItemChildren={(option) => (
                        <div>
                          <strong>{option.title?.en || "Unknown Title"}</strong>
                          <div style={{ fontSize: "12px", color: "#888" }}>
                            {option.subtitle?.en || option.title.en}
                          </div>
                        </div>
                      )}
                    />
                    <button
                      className="btn btn-neon-orange btn-round-edge px-3"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                      onClick={() => window.open("https://app.rawbids.com/", "_blank")}
                    >
                      <i className="fa fa-search d-inline" style={{ marginRight: 5, color: "inherit" }}></i>
                      {t("title356")}
                    </button>
                  </div>
                </div>

                <div>
                  <span
                    className="text-white"
                    style={{ marginBottom: 0, marginTop: 5, paddingBottom: 0, fontWeight: 500, marginRight: 3 }}
                  >
                    {t("title357")}:
                  </span>
                  <a
                    href="https://app.rawbids.com/demo/commodity/6458ae695175287050a4cde7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    Green Tea Extract
                  </a>
                  <a
                    href="https://app.rawbids.com/demo/commodity/6458ae695175287050a4cc30"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    BCAA 2:1:1
                  </a>
                  <a
                    href="https://app.rawbids.com/demo/commodity/6458ae695175287050a4cc93"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    Acerola Extract
                  </a>
                  <a
                    href="https://app.rawbids.com/demo/commodity/6458ae695175287050a4d03c"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="badge badge-dark badge-lg py-1 px-2 mt-0 mx-1"
                    style={{ background: "rgba(255, 255, 255, 0.3)", paddingTop: 0, marginTop: 0 }}
                  >
                    Vitamin C
                  </a>
                </div>
              </div>
            </div>
          </div>
          <video loop autoPlay muted className="html-video herovideo" id="video-10" playsInline>
            <source type="video/mp4" src={`${process.env.PUBLIC_URL}/images/bg.mp4`} />
          </video>
        </section>
        <div className="header align-items-stretch" style={{ height: 40 }}>
          {error && (
            <div className="text-center text-danger p-2">{error}</div>
          )}
          {loading && (
            <div className="text-center p-1">Loading commodity prices...</div>
          )}
          <div className="marquee" style={{ width: "100%", padding: 2 }}>
            {(() => {
              // Duplicate items to fill the screen (minimum 10 items for smooth scrolling)
              let displayPrices = [...prices];
              while (displayPrices.length > 0 && displayPrices.length < 10) {
                displayPrices = [...displayPrices, ...prices];
              }
              const animationDuration = `${displayPrices.length * 5}s`;

              return !loading && prices.length > 0 && (
                <>
                  <div
                    className="header-animation"
                    style={{ animation: `${animationDuration} linear 0s infinite normal none running marquee` }}
                  >
                    {displayPrices.map((item, idx) => (
                      <Price
                        key={`${item.articleId}-${idx}`}
                        link={"https://app.rawbids.com/demo/commodity/" + item.articleId}
                        name={item.title.en}
                        price={`${item.commodityPrice.price.toFixed(2)}€`}
                        percent={`${item.change > 0 ? "+" : ""}${item.change.toFixed(2)}%`}
                        graph={`data:image/svg+xml;utf8,${encodeURIComponent(item.svg)}`}
                        color={item.change <= 0 ? "success" : "danger"}
                      />
                    ))}
                  </div>
                  <div
                    className="header-animation-repeat"
                    style={{ animation: `${animationDuration} linear 0s infinite normal none running marquee` }}
                  >
                    {displayPrices.map((item, idx) => (
                      <Price
                        key={`${item.articleId}-repeat-${idx}`}
                        link={"https://app.rawbids.com/demo/commodity/" + item.articleId}
                        name={item.title.en}
                        price={`${item.commodityPrice.price.toFixed(2)}€`}
                        percent={`${item.change > 0 ? "+" : ""}${item.change.toFixed(2)}%`}
                        graph={`data:image/svg+xml;utf8,${encodeURIComponent(item.svg)}`}
                        color={item.change <= 0 ? "success" : "danger"}
                      />
                    ))}
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation("general")(HeroImage2);
